import {
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  TableRow,
} from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import React, { useEffect } from "react";
import en from "../../../lang/en-us";
import NomineeSummary from "./nominee-summary";
import { connect, useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../../store/reducers";
import { SubmitButton } from "../../../lib/Button";
import { CheckBoxField } from "../../../lib/CheckBoxField";
import { saveNominee } from "../../../store/actions/nct";
import Image from "../../Image";
import { useHistory } from "react-router";

const {
  dashboard,
  dbCommercial,
  signUp: { form },
  common,
} = en;

export const BackArrow = ({ header = "", history, customStyle }: any) => {
  return (
    <h2 className="heading" style={{ padding: 5, fontSize: 14 }}>
      <a onClick={() => history.goBack()} style={{ cursor: "pointer" }}>
        <Image
          height="10"
          width="10"
          src="/images/left-arrow-black.svg"
          alt="icon"
          style={customStyle ? customStyle : { marginTop: 2 }}
        />
        <span style={{ fontSize: 14 }}>Back</span>
      </a>
    </h2>
  );
};

export const ActionHeader = ({ header = "", subHeader, history }: any) => {
  return (
    <h2 className="heading" style={{ padding: 5, fontSize: 16 }}>
      <a onClick={() => history.goBack()} style={{ cursor: "pointer" }}>
        <Image
          height="15"
          width="15"
          src="/images/left-arrow-black.svg"
          alt="icon"
        />
      </a>
      {header}
      {subHeader && <span>{subHeader}</span>}
    </h2>
  );
};

function SelectedFolios(props: any) {
  const [currIndex, setCurrentIndex] = React.useState<number>(-1);
  const { nomineesData, investorData, token } = useSelector(
    ({ NomineeReducer, investor, authReducer }: RootStateType) => ({
      nomineesData: NomineeReducer,
      investorData: investor.investorData,
      token: authReducer.token,
    })
  );
  const [nominees, setNominees] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(false);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [noNomineeFlag, setNoNomineeFlag] = React.useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!nomineesData.length) {
      props.history.goBack();
    }
  }, []);

  const handleChange = (index: number) => {
    if (index === currIndex) {
      setIsExpanded(false);
      setCurrentIndex(-1);
    } else {
      setIsExpanded(true);
      setCurrentIndex(index);
    }
  };

  console.log(token, investorData, "idafa");

  const handleSubmit = async () => {
    const nomineeApiPayload = {
      email: nomineesData[0].email,
      mobile: nomineesData[0].mobile,
      pan: investorData.PAN,
      distributor_id: token,
      data: nomineesData.map((nomineeData) => {
        return {
          folio: nomineeData.folio,
          amc: nomineeData.amc,
          amc_name: nomineeData.amcName,
          noNominee: noNomineeFlag ? "Y" : "",
          nominees: noNomineeFlag ? [] : nomineeData.nominees,
          eNomType: "F",
          eSignFlag: "",
          eNomDocId: "",
        };
      }),
    };
    try {
      setLoading(true);
      const apiRes = await saveNominee(nomineeApiPayload)(dispatch);
      if (apiRes?.status === 201) {
        props.history.replace("/new-transaction/nct-type/success", {
          state: {
            succesMessage: apiRes.message,
          },
        });
      }
    } catch (err: any) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="curved-bg">
      <ActionHeader
        history={props.history}
        header={dashboard.UpdateNominee.UpdateNomineeHeading}
      />
      <div className="curved-bg-content curved-bg-table-outer update-nominee-screen">
        {/* {verifyThrough === VerifyThrough.ESIGN && ( */}
        {/*     <div style={{ marginTop: '15px' }}> */}
        {/*     </div> */}
        {/* )} */}
        <CheckBoxField
          onChange={(e) => setNoNomineeFlag(!noNomineeFlag)}
          style={{ paddinTop: 8, paddingBottom: 8 }}
          value={noNomineeFlag}
          label={dbCommercial.noNominee.indNote}
        />
        <TableContainer component={Paper}>
          <Table>
            <TableHead style={{ backgroundColor: "#f4f2ff" }}>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>
                  {" "}
                  Folio Number{" "}
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  {" "}
                  Investor Name{" "}
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {nomineesData.map((nominee, index: number) => (
                <>
                  <TableRow
                    onClick={() => {
                      handleChange(index);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <TableCell>{nominee.folio}</TableCell>
                    <TableCell>{nominee.investorName}</TableCell>
                    <TableCell
                      onClick={() => {
                        props.history.push(
                          "/new-transaction/nct-type/update-ind-nominee",
                          {
                            nomineesData: nominee,
                            nomineeIndex: index,
                          }
                        );
                      }}
                    >
                      <Image src="/images/edit.svg" alt="icon" />
                    </TableCell>
                    <TableCell>
                      {isExpanded && currIndex === index ? (
                        <KeyboardArrowUp />
                      ) : (
                        <KeyboardArrowDown />
                      )}
                    </TableCell>
                    <TableCell>
                      {nominee.verified || noNomineeFlag
                        ? "Updated"
                        : "Not Updated"}
                    </TableCell>
                  </TableRow>
                  {currIndex === index && isExpanded && (
                    <TableRow>
                      <TableCell colSpan={5}>
                        <NomineeSummary
                          nomineesData={nominee}
                          noNomineeFlagAll={noNomineeFlag}
                          setNominees={setNominees}
                          index={index}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="curved-bg-content-inner-bottom">
          <SubmitButton
            type="submit"
            className="customBtn"
            disabled={
              loading ||
              (!noNomineeFlag &&
                nomineesData.some((nominee: any) => !nominee.verified))
            }
            label={"Submit"}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
}

export default connect(null)(SelectedFolios);
